import { render, staticRenderFns } from "./editGroup.vue?vue&type=template&id=527d5c36&scoped=true&"
import script from "./editGroup.js?vue&type=script&lang=js&"
export * from "./editGroup.js?vue&type=script&lang=js&"
import style0 from "./editGroup.vue?vue&type=style&index=0&id=527d5c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d5c36",
  null
  
)

export default component.exports